export const getExpertisesFrag = `
    code
`;
